









import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class VButtonUpload extends Vue {
  @Prop({ default: "" }) accept!: string;

  change(e: Event) {
    const input = e.target as HTMLInputElement;
    const files = input.files;
    if (!files) return;
    this.$emit("upload", files);
    input.value = "";
  }
}
